import VTextFieldWithValidation from '@/components/inputs/VTextFieldWithValidation';
import VSelectWithValidation from '@/components/inputs/VSelectWithValidation';
import VRadioGroupWithValidation from '@/components/inputs/VRadioGroupWithValidation';

import { ValidationObserver } from 'vee-validate';
import SubmitButton from '@/components/buttons/SubmitButton';
import Alert from '@/components/Alert';
import { setAlert } from '@/classes/alert';

export const formMixin = {
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
    VRadioGroupWithValidation,
    ValidationObserver,
    SubmitButton,
    Alert
  },
  data() {
    return {
      submitButtonLoading: false,
      alertConfig: setAlert({})
    };
  },
  methods: {
    setAlert,
    setError: function(e, i18nKey = 'message') {
      const error = this.$t(e[`${i18nKey}`] || e);
      this.alertConfig = this.setAlert({
        message: error,
        icon: 'mdi-alert-outline'
      });
    }
  }
};
